/**
 * Recipe progress for the pick cards: which specials this card's gem is a
 * component of, and which components are present vs missing. Matching is
 * greedy in recipe order, identical to Game.availableRecipes, so the hints
 * never disagree with the forge buttons.
 */
import { RECIPES } from '../data/balance.js';
import type { GemTypeKey, SpecialKey } from '../data/balance.js';
import type { Game } from '../core/game.js';
import type { GemCell } from '../core/types.js';

export interface RecipeComponentStatus {
  readonly type: GemTypeKey;
  readonly tier: number;
  readonly have: boolean;
}

export interface RecipeStatus {
  readonly key: SpecialKey;
  readonly complete: boolean;
  readonly missing: number;
  readonly comps: readonly RecipeComponentStatus[];
}

export function recipeProgress(game: Game, card: GemCell): RecipeStatus[] {
  if (card.type === undefined) return [];
  const pool = game.combinePool();
  return RECIPES.filter((r) => r.comps.some((c) => c[0] === card.type && c[1] === card.tier)).map(
    (r) => {
      const remaining = pool.slice();
      const comps = r.comps.map(([type, tier]) => {
        const idx = remaining.findIndex((g) => g.type === type && g.tier === tier);
        if (idx !== -1) {
          remaining.splice(idx, 1);
          return { type, tier, have: true };
        }
        return { type, tier, have: false };
      });
      return {
        key: r.key,
        complete: comps.every((c) => c.have),
        missing: comps.filter((c) => !c.have).length,
        comps,
      };
    },
  );
}
